import { createAsyncThunk } from "@reduxjs/toolkit";
import type {
  Issue2faSetupInfoViewModel,
  RecoveryCodesViewModel,
} from "../../../api/axcloud";
import {
  createContract2faApi,
  isAxiosErrorProblemDetails,
} from "../../../api";
import type {
  AccessTokenArg,
  EnableTwoFactorArg,
  SecurityThunkConfig,
} from "./types";

/** 二要素認証の状態と設定情報を取得します。 */
export const resolveTwoFactor = createAsyncThunk<
  Issue2faSetupInfoViewModel,
  AccessTokenArg,
  SecurityThunkConfig
>("security/resolveTwoFactor", async (arg, thunk) => {
  const api = createContract2faApi(arg.accessToken);
  try {
    const response = await api.issue2faSetupInfo();
    return response.data;
  } catch (error) {
    if (isAxiosErrorProblemDetails(error)) {
      return thunk.rejectWithValue(error.response!.data);
    }
    throw error;
  }
});

/** 二要素認証を有効化し、発行されたリカバリーコードを取得します。 */
export const enableTwoFactor = createAsyncThunk<
  RecoveryCodesViewModel,
  EnableTwoFactorArg,
  SecurityThunkConfig
>("security/enableTwoFactor", async (arg, thunk) => {
  const api = createContract2faApi(arg.accessToken);
  try {
    const response = await api.enable2faAsync({
      registerCode: arg.registerCode,
    });
    return response.data;
  } catch (error) {
    if (isAxiosErrorProblemDetails(error)) {
      return thunk.rejectWithValue(error.response!.data);
    }
    throw error;
  }
});

/** 二要素認証を解除します。 */
export const disableTwoFactor = createAsyncThunk<
  void,
  AccessTokenArg,
  SecurityThunkConfig
>("security/disableTwoFactor", async (arg, thunk) => {
  const api = createContract2faApi(arg.accessToken);
  try {
    await api.disable2faAsync();
  } catch (error) {
    if (isAxiosErrorProblemDetails(error)) {
      return thunk.rejectWithValue(error.response!.data);
    }
    throw error;
  }
});
